import { render, staticRenderFns } from "./product-inputs.modal-code.vue?vue&type=template&id=6566c800&scoped=true"
import script from "./product-inputs.modal-code.vue?vue&type=script&lang=js"
export * from "./product-inputs.modal-code.vue?vue&type=script&lang=js"
import style0 from "./product-inputs.modal-code.vue?vue&type=style&index=0&id=6566c800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566c800",
  null
  
)

export default component.exports